"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoJSONParserNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'GEOJSON-PARSER';
class GeoJSONParserNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            try {
                let geoJson;
                const output = { latitude: null, longitude: null, geojson: null };
                const result = params.source;
                if (result && typeof result === 'string') {
                    geoJson = JSON.parse(result);
                }
                // object type not supported at the moment.
                if (result && typeof result === 'object') {
                    geoJson = result;
                }
                // the geoJson is wrong by the types, but we can't realistically expand our types to include GeoJSON.
                //eslint-disable-next-line
                //@ts-ignore
                output.geojson = geoJson;
                if (geoJson) {
                    if (geoJson.type === 'Point') {
                        output.latitude = geoJson.coordinates[1];
                        output.longitude = geoJson.coordinates[0];
                    }
                    else if (geoJson && geoJson.type === 'Feature') {
                        if (geoJson.geometry.type === 'Point') {
                            output.latitude = geoJson.geometry.coordinates[1];
                            output.longitude = geoJson.geometry.coordinates[0];
                        }
                    }
                }
                return output;
            }
            catch (e) { }
            return null;
        };
        // We have to redefine our inputparams to handle geoJson objects
        this._interfaceDefinition = {
            definitions: Object.assign(Object.assign({}, Schema.definitions), { InputParams: {
                    type: 'object',
                    properties: {
                        source: {
                            anyOf: [
                                {
                                    $ref: '/Geography/GeoJSON',
                                },
                                {
                                    description: 'Input',
                                    type: 'string',
                                    title: 'source',
                                },
                            ],
                        },
                    },
                    required: ['source'],
                } }),
        };
    }
}
exports.GeoJSONParserNode = GeoJSONParserNode;
GeoJSONParserNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'GeoJSON Parser',
    isIdempotent: true,
    primaryCategory: 'Geography',
};
//# sourceMappingURL=GeoJSONParser.js.map